import * as api from '../api/authorization';
import { toGroup } from '../converters/permissionsConverter';
import { asyncAction } from './common';

// Данные текущего пользователя одним запросом. FETCH_ME_SUCCESS обрабатывают reducer'ы
// login (tenants + sessionExpiresAt) и authorization/me (permissionsByTenant).
export const fetchMe = () => asyncAction('FETCH_ME', api.fetchMe());

export const fetchGroups = () => asyncAction('FETCH_AUTHORIZATION_GROUPS', api.fetchGroups());

export const updateGroup = (group) =>
  asyncAction('UPDATE_AUTHORIZATION_GROUP', api.saveGroup(toGroup(group)));

export const deleteGroup = (groupId) =>
  asyncAction('DELETE_AUTHORIZATION_GROUP', api.deleteGroup(groupId));

export const startUpdateGroup = (group = null) => ({
  type: 'UPDATE_AUTHORIZATION_GROUP',
  group,
});

export const cancelUpdateGroup = () => ({
  type: 'CANCEL_UPDATE_AUTHORIZATION_GROUP',
});

export const setGroupId = (groupId) => ({
  type: 'UPDATE_SET_AUTHORIZATION_GROUP_ID',
  groupId,
});

export const setGroupPermissions = (permissions) => ({
  type: 'UPDATE_SET_AUTHORIZATION_GROUP_PERMISSIONS',
  permissions,
});

export const setTabKey = (key) => ({
  type: 'UPDATE_SET_AUTHORIZATION_TAB_KEY',
  key,
});
